import { useState, useCallback } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const useAldreteValidation = (formData) => {
  const { showNotification } = useNotification();
  const [errors, setErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = "";
    switch (name) {
      case 'surgery_procedure':
        if (!value || !value.trim()) error = "Surgery/Procedure is required";
        break;
      case 'anaesthesia':
        if (!value || !value.trim()) error = "Anesthesia is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  }, []);

  const validateForm = useCallback(() => {
    const requiredFields = [
      { key: 'surgery_procedure', label: 'Surgery / Procedure' },
      { key: 'anaesthesia', label: 'Anaesthesia Type' },
    ];

    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '') {
        tempErrors[key] = `${label} is required`;
      }
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { 
        el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        el.focus(); 
      }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }

    return Object.keys(tempErrors).length === 0;
  }, [formData, showNotification]);

  return { errors, setErrors, validateField, validateForm };
};
